import React, { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';

import { useAppSelector } from 'store/hooks';
import { Raffle } from 'api/raffle/raffle_detail';
import { blockchainUnit } from 'lib/blockChain';

interface ICoreInfoProps {}

const MintInfo: React.FC<ICoreInfoProps> = ({}) => {
  const { raffleInfo } = useAppSelector((state) => state.raffleDetails);
  const [raffle, setRaffle] = useState<Raffle>();

  useEffect(() => {
    setRaffle(raffleInfo);
  }, [raffleInfo]);

  const mintLocalFormat = useMemo(() => {
    if (!!raffle?.project?.mint_date && !!raffle?.project?.mint_time) {
      return dayjs(
        `${dayjs.utc(raffle?.project?.mint_date).format('YYYY-MM-DD')}T${
          raffle?.project?.mint_time
        }Z`
      )
        .utc()
        .local()
        .format('MM/DD/YYYY HH:mm:ss');
    } else if (!!raffle?.project?.mint_date && !raffle?.project?.mint_time) {
      return dayjs(raffle?.project?.mint_date).format('MM/DD/YYYY');
    } else {
      return null;
    }
  }, [raffle?.project?.mint_date, raffle?.project?.mint_time]);

  if (
    !raffle?.project?.blockchain &&
    (!raffle?.project?.supply_count ||
      Number(raffle?.project?.supply_count) === 0) &&
    (!raffle?.project?.whitelist_count ||
      Number(raffle?.project?.whitelist_count) === 0) &&
    !raffle?.project?.mint_date &&
    (!raffle?.project?.public_price || raffle?.project?.public_price === '') &&
    Number(raffle?.project?.public_price) !== 0 &&
    (!raffle?.project?.whitelist_price ||
      raffle?.project?.whitelist_price === '') &&
    Number(raffle?.project?.whitelist_price) !== 0
  ) {
    return <div className="py-6"></div>;
  }

  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 text-sm font-normal text-neutral-400">
      {!!raffle?.project?.blockchain && (
        <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] bg-neutral-800 px-2">
          <div>Blockchain</div>
          <div className="font-medium text-neutral-100">
            {raffle?.project?.blockchain.split('_').join(' ')}
          </div>
        </div>
      )}

      {!!raffle?.project?.supply_count &&
        Number(raffle?.project?.supply_count) !== 0 && (
          <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] bg-neutral-800 px-2">
            <div>Supply Count</div>
            <div className="font-medium text-neutral-100">
              {raffle?.project?.supply_count}
            </div>
          </div>
        )}

      {!!raffle?.project?.whitelist_count &&
        Number(raffle?.project?.whitelist_count) !== 0 && (
          <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] bg-neutral-800 px-2">
            <div>Whitelist Count</div>
            <div className="font-medium text-neutral-100">
              {raffle?.project?.whitelist_count}
            </div>
          </div>
        )}

      {(!(
        !raffle?.project?.public_price || raffle?.project?.public_price === ''
      ) ||
        Number(raffle?.project?.public_price) === 0) && (
        <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] bg-neutral-800 px-2">
          <div>Public Price</div>
          <div className="font-medium text-neutral-100">
            {Number(raffle?.project?.public_price) !== 0
              ? `${raffle?.project?.public_price} ${blockchainUnit(
                  raffle?.project?.blockchain
                )}`
              : 'Free'}
          </div>
        </div>
      )}
      {(!(
        !raffle?.project?.whitelist_price ||
        raffle?.project?.whitelist_price === ''
      ) ||
        Number(raffle?.project?.whitelist_price) === 0) && (
        <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] bg-neutral-800 px-2">
          <div>Whitelist Price</div>
          <div className="font-medium text-neutral-100">
            {Number(raffle?.project?.whitelist_price) !== 0
              ? `${raffle?.project?.whitelist_price} ${blockchainUnit(
                  raffle?.project?.blockchain
                )}`
              : 'Free'}
          </div>
        </div>
      )}

      {!!raffle?.project?.mint_date && (
        <div className="flex h-7 items-center justify-center gap-1 rounded-[52px] bg-neutral-800 px-2">
          <div>Mint Time</div>
          <div className="font-medium text-neutral-100">{mintLocalFormat}</div>
        </div>
      )}
    </div>
  );
};

export default MintInfo;
